export interface QuickActionVisibility {
  akte: true;
  forderung: boolean;
  forderungLabel: 'Forderung' | 'Forderung anlegen';
  extras: boolean;
}

export function getQuickActionVisibility(
  zahlungsstatus: string | null | undefined,
  forderungsakte_id: string | null | undefined,
): QuickActionVisibility {
  const isBezahlt = zahlungsstatus === 'bezahlt';
  const hasForderung = !!forderungsakte_id;
  return {
    akte: true,
    forderung: !isBezahlt,
    forderungLabel: hasForderung ? 'Forderung' : 'Forderung anlegen',
    extras: !isBezahlt && hasForderung,
  };
}
